import { render, staticRenderFns } from "./NewSelectRemote.vue?vue&type=template&id=55a58b0a&scoped=true"
import script from "./NewSelectRemote.vue?vue&type=script&lang=js"
export * from "./NewSelectRemote.vue?vue&type=script&lang=js"
import style0 from "./NewSelectRemote.vue?vue&type=style&index=0&id=55a58b0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a58b0a",
  null
  
)

export default component.exports